<template>
  <MovementList
    :scope-type="scopeType"
    :scope-id="scopeId"
    :key="scopeId"
  />
</template>

<script>
import MovementList from './MovementList.vue'

export default {
  name: 'MovementIndex',
  components: { MovementList },
  computed: {
    scopeType() {
      return this.$route.meta.scopeType || 'pica-service'
    },
    scopeId() {
      if (this.scopeType === 'pica-service') {
        return this.$route.params.picaServiceId
      } else if (this.scopeType === 'contract-manager') {
        return this.$route.params.contractManagerId
      } else if (this.scopeType === 'global') {
        return null
      }
      return null
    }
  }
}
</script>
